const isAppleOS = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)

export default {
  isAppleOS,
  emojiType: isAppleOS ? 'apple' : 'google'
}
